import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const dashboard: AppRouteModule = {
  path: '/dashboard',
  name: 'Dashboard',
  component: LAYOUT,
  redirect: '/dashboard/index',
  meta: {
    orderNo: 10,
    hideMenu: true,
    title: 'dashboard',
  },
  children: [
    {
      path: 'index',
      name: 'Index',
      component: () => import('/@/views/dashboard/index.vue'),
      meta: {
        title: '仪表盘',
      },
    },
  ],
};

export default dashboard;
